import {
    ACTIVATELEVEL,
} from "../type";

export function ActivateLevel(activate) {
  return (dispatch, getState) => {
            dispatch({ type:ACTIVATELEVEL , payload:activate });

  }
  }
